import React, { useState } from "react";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { toast } from "react-toastify";

// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import OrderDetails from "./OrderDetails";
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTable from "../../../shares/PanelTable";
import PanelTemplate from "../../../shares/PanelTemplate";
import { fixNumbers } from "../../../../utils";
import ReturnOrder from "../ReturnOrder/ReturnOrder";
import PrintIcon from "@mui/icons-material/Print";
import MuiButton from "../../../shares/MuiButton";
import { useNavigate } from "react-router-dom";
import PrintOrderDetailNavigator from "../PrintOrderDetailNavigator";
import PreOrderDetails from "./PreOrderDetails";

const headersList = [
  { colName: "unique_id", name: "سند" },
  { colName: "created_at", name: "تاریخ تحویل سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "details", name: "جزییات سفارش" },
  { colName: "details", name: "جزییات پیش سفارش" },
  { colName: "print", name: "چاپ سفارش" },

  // { colName: "total", name: "مرجوعی" },
];

const mobileHeadersList = [
  { colName: "unique_id", name: "کد سفارش" },
  { colName: "created_at", name: "تاریخ تحویل سفارش" },
  { colName: "total", name: "وزن" },
  // { colName: "total", name: "مرجوعی" },
];

const dataKey = ["unique_id", "created_at", "total"];

const ReceviedOrders = (props) => {
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [codeFilter, setCodeFilter] = useState(null);
  const { userData } = useUserData();
  const navigate = useNavigate();

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
  ];

  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderDetails
          selectedRow={it}
          getCompleteOrderApi={getCompleteOrderApi}
        />
      ),
    },
    {
      label: "جزییات پیش سفارش",
      component: (it) => (
        <PreOrderDetails
          selectedRow={it}
          getCompleteOrderApi={getCompleteOrderApi}
        />
      ),
    },

    // {
    //   label: "مرجوعی سفارش",
    //   component: (it) => (
    //     <ReturnOrder
    //       selectedRow={it}
    //       getCompleteOrderApi={getCompleteOrderApi}
    //     />
    //   ),
    // },
  ];

  const actionsList = [
    {
      label: "چاپ",
      component: (it) => (
        <PrintOrderDetailNavigator inCurrentOrder selectedRow={it} />
      ),
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const [receviedOerdersList, setReceviedOerdersList] = useState({
    results: [],
  });

  const getCompleteOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/customer_get_complete_order`,
    params: { unique_id: fixNumbers(codeFilter) },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setReceviedOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    if (codeFilter !== null) {
      setIsFilterOn(true);
      getCompleteOrderApi.reFetch();
    }
  };

  const reset_filter = () => {
    setCodeFilter(null);
    getCompleteOrderApi.reFetch();
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setReceviedOerdersList({ results: [] });
    getCompleteOrderApi.reFetch();
  };
  const handelPrintReport = () => {
    //   navigate(`/print-current-orders/recevied/${codeFilter}/`);
    // };
    window.open(
      `/print-current-orders/recevied/${codeFilter}/`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="recevied-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های تحویل گرفته شده</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست سفارش‌های تحویل گرفته شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={receviedOerdersList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
          />
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default ReceviedOrders;
